import { render, staticRenderFns } from "./addAndEdit.vue?vue&type=template&id=a1b9c5f8&scoped=true&"
import script from "./addAndEdit.vue?vue&type=script&lang=ts&"
export * from "./addAndEdit.vue?vue&type=script&lang=ts&"
import style0 from "./addAndEdit.vue?vue&type=style&index=0&id=a1b9c5f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1b9c5f8",
  null
  
)

export default component.exports